import {
  ShieldCheck,
  Users,
  CirclesThreePlus,
  MapPin,
} from "@phosphor-icons/react";
import { useLang } from "../context/LanguageContext";

const ICONS = [ShieldCheck, Users, CirclesThreePlus, MapPin];

export const WhyUs = () => {
  const { t } = useLang();

  return (
    <section
      id="whyus"
      data-testid="whyus-section"
      className="relative scroll-mt-[160px] md:scroll-mt-[210px] lg:scroll-mt-[240px] bg-gradient-to-b from-[#d6e6f2] to-[#cfe0f0] py-24 lg:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="font-mono text-[11px] uppercase tracking-[0.28em] text-blue-600">
              {t.whyus.overline}
            </div>
            <h2
              data-testid="whyus-title"
              className="font-heading mt-5 text-3xl font-bold tracking-tight text-slate-900 md:text-4xl lg:text-5xl"
            >
              {t.whyus.title}
            </h2>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-slate-600">
              {t.whyus.subtitle}
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm sm:grid-cols-2">
              {t.whyus.points.map((p, i) => {
                const Icon = ICONS[i % ICONS.length];
                const border =
                  i % 2 === 0
                    ? "sm:border-r sm:border-slate-200"
                    : "";
                const bottom =
                  i < t.whyus.points.length - 2
                    ? "border-b border-slate-200"
                    : "";
                return (
                  <div
                    key={p.title}
                    data-testid={`whyus-point-${i}`}
                    className={`group p-8 transition-colors hover:bg-slate-50 ${border} ${bottom}`}
                  >
                    <div className="icon-tile">
                      <Icon size={22} weight="duotone" />
                    </div>
                    <h3 className="font-heading mt-6 text-lg font-semibold text-slate-900 md:text-xl">
                      {p.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-600">
                      {p.desc}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
